<template>
  <div class="info-panel top-left">
    <!-- 真太阳时和四柱信息 -->
    <div class="info-row">
      <span class="info-label">真太阳时：</span>
      <span class="info-value">{{ formattedFateData.trueSolarTime || '待计算' }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">四柱：</span>
      <span class="info-value">{{ formattedFateData.fourPillars || '待计算' }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">姓名：</span>
      <span class="info-value">{{ info.name || '未填写' }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">地址：</span>
      <span class="info-value">{{ info.address || '未填写' }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">公历：</span>
      <span class="info-value">{{ info.solarDate || '未填写' }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">北京时间：</span>
      <span class="info-value">{{ info.beijingTime || '未填写' }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">时区：</span>
      <span class="info-value">{{ info.timezone || '未填写' }}</span>
    </div>
    <!-- 农历（万年历口径，2026-10-15 新增）：数据与右侧表单的「农历」行同源（info.wannianliLunarDate） -->
    <div class="info-row">
      <span class="info-label">农历：</span>
      <span class="info-value">{{ info.wannianliLunarDate || '待计算' }}</span>
    </div>
    <!-- 星雲鑑历（星雲鑑口径，2026-10-15 由「农历」改名）：来自后端 /fateCalculate。
         颜色与面板其它行一致（白色）；"申子辰"那个蓝色改到右侧表单使用（2026-10-15 调整） -->
    <div class="info-row">
      <span class="info-label">星雲鑑历：</span>
      <span class="info-value">{{ formattedFateData.lunarDate || '待计算' }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">经度：</span>
      <span class="info-value">{{ info.longitude }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">纬度：</span>
      <span class="info-value">{{ info.latitude }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">分宫制：</span>
      <span class="info-value">{{ info.hsys }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">星盘类型：</span>
      <span class="info-value">{{ info.astrolabeType }}</span>
    </div>
  </div>
</template>

<script>
const { formatFateDisplayData } = require('../../utils/fateDisplayFormat')

export default {
  name: 'InfoPanel',
  props: {
    info: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        address: '',
        solarDate: '',
        beijingTime: '',
        timezone: '',
        lunarDate: '',
        // 万年历农历（与右侧表单「农历」同源）
        wannianliLunarDate: '',
        lunarTime: '',
        longitude: '',
        latitude: '',
        hsys: '',
        astrolabeType: ''
      })
    },
    fateData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formattedFateData () {
      return formatFateDisplayData(this.fateData)
    }
  }
}
</script>

<style scoped>
.info-panel {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(255, 255, 255, 0.0);
  padding: 15px;
  border-radius: 8px;
  z-index: 100;
  width: 280px;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
}

.info-label {
  font-weight: bold;
  width: 84px;
  color: #fff;
}

.info-value {
  flex: 1;
  color: #fff;
  word-break: break-word;
}

/* 手机：整块面板缩小（字号、宽度、行距）并更贴近左上角，
   尽量减少对星盘画布的遮挡。宽度再小就会挤坏「分宫制 / 星盘类型」这类字段，
   所以缩到 180px 为止。 */
@media (max-width: 900px) {
  .info-panel {
    top: 6px;
    left: 6px;
    width: 180px;
    padding: 8px;
  }
  .info-row {
    margin-bottom: 4px;
    font-size: 12px;
  }
  .info-label {
    width: 60px;
  }
}
</style>
